import React from "react"
import classnames from "classnames"
import {
  H1,
  H6,
  Visible,
  ZoomZoomIcon,
  SlugIcon,
  ButtonIcon
} from "AtomicComponents"
import { VideoPlayer, BrowserHeightSection } from "AtomicContainers"
import { IS_IE, IS_EDGE } from "AtomicUtils/environment"
import componentParser from "AtomicUtils/componentParser"
import styles from "./Hero.less"

class Hero extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {
      height: 50
    }
  }


  _setHeight = (height) => {
    this.setState({
      height: height
    })
  }

  render() {
    let {
      backgroundVideo,
      heading,
      preHeading,
      components,
      mobileBackgroundVideo,
      mobileBackgroundImage,
      backgroundImage,
      mobileHeading,
      mobilePreHeading,
      glow,
      icon,
      scrollToSlug,
      gtm
    } = this.props

    const { height } = this.state

    if (!mobileHeading) mobileHeading = heading
    if (!mobilePreHeading) mobilePreHeading = preHeading


    return (
      <div className={classnames({
        [styles.Hero]: true
      })}>
        <BrowserHeightSection setHeight={this._setHeight}>
          <div
            ref={c => this.heroInside = c}
            className={classnames({
              [styles.HeroInside]: true
            })}
          >
            <Visible visible={["screen","tablet"]}>
              <VideoPlayer
                poster={backgroundImage}
                src={backgroundVideo}
                height={(IS_IE || IS_EDGE) ? "100%" : height + "px"}
                calculatedHeight
                visible
              />
              {heading &&
                <div
                  className={classnames({
                    [styles.HeroContent]: true
                  })}
                >
                  {preHeading &&
                    <H6 withDetails white>{preHeading}</H6>
                  }
                  {heading &&
                    <H1 white withDetails glow={glow}>
                      {heading}
                    </H1>
                  }
                </div>
              }
            </Visible>
            <Visible visible={["mobile"]}>
              <VideoPlayer
                poster={mobileBackgroundImage || backgroundImage}
                src={mobileBackgroundVideo || backgroundVideo}
                height={`${height}px`}
                calculatedHeight
                visible
              />
              {mobileHeading &&
                <div
                  className={classnames({
                    [styles.HeroContent]: true
                  })}
                >
                  {mobilePreHeading &&
                    <H6 white withDetails>{mobilePreHeading}</H6>
                  }
                  {mobileHeading &&
                    <H1 white withDetails glow={glow}>
                      {mobileHeading}
                    </H1>
                  }
                </div>
              }
            </Visible>

            <div
              className={classnames({
                [styles.Bottom]: true
              })}
            >

              <div
                className={classnames({
                  [styles.ColumnIn]: true,
                  [styles.ZoomZoom]: true
                })}
              >
                {icon ? <img src={icon} /> : <ZoomZoomIcon />}
              </div>
              <div
                className={classnames({
                  [styles.ColumnIn]: true,
                  [styles.Center]: true,
                  [styles.White]: true
                })}
              >
                {componentParser(components)}
              </div>

              <div
                className={classnames({
                  [styles.ColumnIn]: true,
                  [styles.Slug]: true
                })}
                >
                {scrollToSlug && scrollToSlug!='' &&
                  <ButtonIcon
                    href={`#${scrollToSlug}`}
                    gtm={{
                      category: gtm && gtm.category ? gtm.category : "Hero",
                      action: gtm && gtm.action ? gtm.action : `Clicked Scroll to Slug - ${scrollToSlug}`
                    }}>
                    <SlugIcon />
                  </ButtonIcon>
                }
              </div>
            </div>
          </div>
        </BrowserHeightSection>
      </div>
    )
  }
}


export default Hero



// WEBPACK FOOTER //
// ./src/AtomicContainers/Hero/Hero.jsx